"use strict";

define('service/meeting',['appkit/service'], function (Service) {
  var MeetingService = Service.extend({
    generateMinutes: function generateMinutes(meeting) {
      this.app.execute('download', {
        method: 'GET',
        url: meeting.getMinutesURL()
      });
    },
    generateAgenda: function generateAgenda(meeting) {
      this.app.execute('download', {
        method: 'GET',
        url: meeting.getAgendaURL()
      });
    }
  });
  return MeetingService;
});

